export default function no_auth_exportProductCompareDataToXLS()
{
    return {
        'PartNumber': 'PartNumber',
        'DataSheet': 'DataSheet',
        'Manufacturer': 'Manufacturer'
    }
};